<template>
  <div>
    <v-container
      id="regular-tables"
      fluid
      tag="section"
    >
    <v-row
      v-if="this.$route.params.convocatoria"
      class="pa-4"
    >
      <v-btn
                color="primary"
                :loading="isLoadingDownload"
              @click="exportarExcel"
              >
                Descargar data
                <v-icon> mdi-download </v-icon>
      </v-btn>
      <v-col
        class="py-0 my-0"
      />
      <v-btn
        class="ma-2"
        outlined
        color="indigo"
        @click="volverDeConvocatoria"
      >
      <v-icon dark>
            mdi-arrow-left
          </v-icon>
        Regresar
      </v-btn>
    </v-row>
        <!-- :items="entidadesTecnicasConNegociacion" -->
      <v-data-table
        :headers="headers"
        :items="entidadTecnicaTotales"
        item-key="name"
        class="elevation-1"
        :search="search"
        :loading="isLoadingTable"
      >
      
        <template v-slot:top>
          <v-row
            class="pa-8"
          >
            <v-col
              v-if="isAdmin"
            >
              <v-select
                v-model="asesorSeleccionado"
                outlined
                label="Asesor"
                :items="asesores"
                @change="filtroTabla()"
              />
                <!-- item-text="email"
                item-value="uid" -->
            </v-col>
            <v-col
              v-if="isAdmin"
            >
              <v-select
              v-model="estadoEntidadTecnicaSeleccionado"
                outlined
                label="Estado de entidad técnica"
                :items="estadoEntidadTecnicas"
                @change="filtroTabla()"
              />
            </v-col>
            <v-col
              v-if="isAdmin"
            >
              <v-select
              v-model="estadoDeNegociacionSeleccionado"
                outlined
                label="Estado de negociación"
                :items="estadosDeNegociacion"
                @change="filtroTabla()"
              />
            </v-col>
            <v-col
              v-if="isAdmin"
            >
              <v-select
                v-model="FechaDeFacturacionSeleccionada"
                outlined
                label="Fecha facturación"
                :items="['Todos', '2021-07','2021-09','2021-10','2021-11','2021-12','2022-01','2022-02','2022-03','2022-04','2022-05','2022-06','2022-07','2022-08', '2022-09', '2022-10', '2022-11', '2022-12', '2023-01', '2023-02', '2023-03', '2023-04', '2023-05', '2023-06', '2023-07', '2023-08', '2023-09', '2023-10', '2023-11', '2023-12', '2024-01', '2024-02', '2024-03', '2024-04', '2024-05', '2024-06', '2024-07', '2024-08', '2024-09', '2024-10', '2024-11', '2024-12', '2025-01', '2025-02', '2025-03', '2025-04', '2025-05', '2025-06', '2025-07', '2025-08', '2025-09', '2025-10', '2025-11', '2025-12', '2026-01', '2026-02', '2026-03', '2026-04', '2026-05', '2026-06', '2026-07', '2026-08', '2026-09', '2026-10', '2026-11', '2026-12', '2027-01', '2027-02', '2027-03', '2027-04', '2027-05', '2027-06', '2027-07', '2027-08', '2027-09', '2027-10', '2027-11', '2027-12', '2028-01', '2028-02', '2028-03', '2028-04', '2028-05', '2028-06', '2028-07', '2028-08', '2028-09', '2028-10', '2028-11', '2028-12', '2029-01', '2029-02', '2029-03', '2029-04', '2029-05', '2029-06', '2029-07', '2029-08', '2029-09', '2029-10', '2029-11', '2029-12', '2030-01', '2030-02',]"
                @change="filtroTabla()"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="search"
                outlined
                label="Buscar en entidad tecnica..."
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.accions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                @click="editarEntidadTecnica(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip 
            v-if="isAdmin"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="dialogDelete(item)"
              >
                mdi-trash-can-outline
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2 ml-2"
                v-bind="attrs"
                @click="agregarContactosDeEntidadTecnica(item)"
                v-on="on"
              >
                mdi-card-account-phone
              </v-icon>
            </template>
            <span>Contactos</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="verificarDireccion(item)"
              >
                mdi-clipboard-text-outline
              </v-icon>
            </template>
            <span>Prospección</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="comentariosEntidadTecnica(item)"
              >
                mdi-comment-quote
              </v-icon>
            </template>
            <span>Comentarios</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="negociar(item)"
              >
                mdi-handshake
              </v-icon>
            </template>
            <span>Negociar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-container>

    <v-btn
      class="mx-2"
      right
      absolute
      fab
      dark
      color="indigo"
      @click="addEntidadTecnica"
    >
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn>

    <add-entidad-tecnica 
      ref="addEntidadTecnica"
      :convocatoria="convocatoria"
      @onAgregarEntidadTecnica="onAgregarEntidadTecnica"
    />
    <new-entidad-tecnica
      ref="newEntidadTecnica"
      @onCreate="onCreate"
    />
    <agregar-por-excel
      ref="uploadExcel"
      @onUploadExcel="onUploadExcel"
    />
    
    <dialog-personalizado
      ref="dialogEntidades"
      @onDialog="onDialog"
    />

    <view-map-component
      ref="viewMap"
      @onDialog="onDialog"
    />

    <wait-gps-component
    :dialog-wait-gps="dialogWaitGps"
    >
    </wait-gps-component>

    <negociar-entidad-tecnica
      ref="negociarEntidadTecnica"
      @onNegociar="onNegociar"
    />
    <comentarios
      ref="comentariosConvocatoria"
      @onComentario="onComentario"
    />

</div>
</template>

<script>

  import AddEntidadTecnica from './components/AgregarRelacionDeEntidadTecnica.vue'
  import NegociarEntidadTecnica from './components/NegociarEntidadTecnica.vue'
  import NewEntidadTecnica from './../Entidades Tecnicas/components/NewEntidadTecnica.vue'
  import DialogPersonalizado from './../components/Dialog.vue'
  import AgregarPorExcel from './../Entidades Tecnicas/components/AgregarPorExcel.vue'
  import ViewMapComponent from './../Entidades Tecnicas/ViewMapComponent.vue'
  import WaitGpsComponent from './../Entidades Tecnicas/components/WaitGpsComponent.vue'
  import Comentarios from './../comentarios/Comentarios.vue'

  import xlsx from 'json-as-xlsx'

  import firebase from 'firebase'

  const db = firebase.firestore()

  export default {
    components: {
      NewEntidadTecnica,
      DialogPersonalizado,
      AgregarPorExcel,
      ViewMapComponent,
      WaitGpsComponent,
      AddEntidadTecnica,
      NegociarEntidadTecnica,
      Comentarios,
    },
    data () {
      return {
        isLoadingTable: false,
        isLoadingDownload: false,
        convocatoria: {},
        dialogWaitGps: false,
        Latitude: 0,
        Longitude: 0,
        zoomMap: 13,
        search: '',
        headers: [
          { text: 'Razon Social', value: 'razon_social' },
          { text: 'Número de modulos', value: 'cantidad_de_modulos' },
          { text: 'Posibilidad de cierre', value: 'porcentaje_de_cierre' },
          { text: 'Monto', value: 'monto_en_soles' },
          { text: 'Zona', value: 'zona' },
          { text: 'Estado', value: 'estado' },
          { text: 'Estado de negociación', value: 'estado_de_negociacion' },
          { text: 'Accions', value: 'accions' },

        ],
        entidadesTecnicas: [],
        entidadTecnicaTotales: [],
        negociaciones: [],
        entidadesTecnicasConNegociacion: [],
        auxiliarEntidadesTecnicasConNegociacion: [],
        asesorSeleccionado: 'Todos',
        estadoEntidadTecnicaSeleccionado: 'Todos',
        estadoDeNegociacionSeleccionado: 'Todos',
        FechaDeFacturacionSeleccionada: 'Todos',
        asesores: ['Todos'],
        estadoEntidadTecnicas: [],
        estadosDeNegociacion: [],
        payload: {}
      }
    },
    computed: {
      isAdmin () {
        return JSON.parse(localStorage.userAuth).perfil !== 'Administrador' ? false : 'a'
      },
    },
    mounted () {
      this.tienePrametrosDeConvocatoria()
      this.getDataFilters()
    },
    methods: {
      async tienePrametrosDeConvocatoria () {
        if (!this.$route.params.convocatoria) {
          this.$router.push({ name: 'Convocatorias' })
          } else {
            this.convocatoria = this.$route.params.convocatoria
            await this.getEntidadesTecnicas()
            // await this.getEntidadesTecnicasPorNombreDeConvocatoria()
        }
      },
      async getEntidadesTecnicas () {
        this.entidadTecnicaTotales = []
        this.isLoadingTable = true
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/convocatoria/' + this.convocatoria.id)
        const data = await response.json()
        this.isLoadingTable = false
        if (data.success) {
          if (data.success) {}
          this.entidadTecnicaTotales = data.data
          this.auxiliarEntidadesTecnicasConNegociacion = data.data
        } else {
          this.$router.push({ name: 'Convocatorias' })
        }
      },
      // async getNegociacionDeEntidadesTenicas () {
      //   this.negociaciones = []
      //   for (let i = 0; i < this.entidadesTecnicas.length; i++) {
      //     await db.collection('Negocicion').where('id', '==', this.entidadesTecnicas[i].id + this.$route.params.convocatoria?.nombre).get().then(negociciones => {
      //       negociciones.forEach(negociacion => {
      //         const payload = {
      //           ...negociacion.data(),
      //           idNegociacion: negociacion.data().id,
      //           porcentajeDeCierre: negociacion.data().porcentajeDeCierre + '%',
      //           ...this.entidadesTecnicas[i],
      //           idEntidadTecnica: this.entidadesTecnicas[i].id,
      //         }
      //         this.negociaciones.push(payload)
      //       })
      //     })
      //   }
      // },
      async getEntidadesTecnicasConNegociacion () {
        const newEntidadesTecnicasTotales = []
        await newEntidadesTecnicasTotales.push(...this.entidadesTecnicas)
        await newEntidadesTecnicasTotales.push(...this.negociaciones)
        this.entidadesTecnicasConNegociacion = this.eliminarDuplicados(newEntidadesTecnicasTotales, 'id')
        this.auxiliarEntidadesTecnicasConNegociacion = [...this.entidadesTecnicasConNegociacion]
      },
      eliminarDuplicados (array, id) {
        const newArray = []
        const lookupObject = {}
        for (var i in array) {
            lookupObject[array[i][id]] = array[i]
        }
        for (i in lookupObject) {
            newArray.push(lookupObject[i])
        }
          return newArray
      },
      async getDataFilters () {
        // this.asesores = this.$store.state.asesores
        this.estadoEntidadTecnicas = ['Todos', ...this.$store.state.estadosEntidadTecnica]
        this.estadosDeNegociacion = ['Todos', ...this.$store.state.estadosNegociacionEntidadTecnica]
        await db.collection('users').get().then(users => {
          users.forEach(user => {
            this.asesores.push(user.data().email)
          })
        })
      },
      newEntidadTecnica () {
        this.$refs.newEntidadTecnica.open()
      },
      onCreate () {
        this.tienePrametrosDeConvocatoria()
      },
      editarEntidadTecnica (entidadTecnica) {
        this.$refs.newEntidadTecnica.open(entidadTecnica)
      },
      dialogDelete (item) {
        this.$refs.dialogEntidades.open('Quitar entidad técnica', '¿Esta seguro de quitar esta entidad tecnica?', item)
      },
      onDialog (data) {
        this.eliminarEntidadTecnica(data)
      },
      async eliminarEntidadTecnica (entidadTecnica) {
        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/delete/entidad/' + this.convocatoria?.id + '/' + entidadTecnica.id, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          }
        })
        const data = await response.json()
        if (data.success) {
          this.$refs.dialogEntidades.close()
          this.tienePrametrosDeConvocatoria()
        } else {
          this.$refs.dialogEntidades.close()
          this.tienePrametrosDeConvocatoria()
        }
      },
      uploadExcel () {
        this.$refs.uploadExcel.open()
      },
      onUploadExcel () {
        this.tienePrametrosDeConvocatoria()
      },
      verificarDireccion (item) {
          this.$router.push({ name: 'verificacion direccion de entidades de una convocatoria', params: { item: item, isConvocatoria: true, convocatoria: this.$route.params.convocatoria } })
      },
      agregarContactosDeEntidadTecnica (item) {
          this.$router.push({ name: 'Contactos de entidad', params: { entidadId: item.id, isConvocatoria: true, convocatoria: this.$route.params.convocatoria } })
      },
      onVerificar () {
      },
      volverDeConvocatoria () {
        this.$router.push({ name: 'Convocatorias' })
      },
      comentariosEntidadTecnica (item) {
        this.$refs.comentariosConvocatoria.open(item, this.convocatoria)
          // this.$router.push({ name: 'comentarios', params: { entidadId: item.id, isConvocatoria: true, convocatoria: this.$route.params.convocatoria } })
      },
      addEntidadTecnica () {
        this.$refs.addEntidadTecnica.open()
      },
      onAgregarEntidadTecnica () {
        this.tienePrametrosDeConvocatoria()
      },
      negociar (item) {
        this.$refs.negociarEntidadTecnica.open(item, this.convocatoria)
      },
      onNegociar () {
        this.tienePrametrosDeConvocatoria()
      },
      onComentario () {

      },
      filtroTabla () {
        this.isLoadingTable = true
        this.entidadTecnicaTotales = [...this.auxiliarEntidadesTecnicasConNegociacion]
        if (this.FechaDeFacturacionSeleccionada !== 'Todos') {
          this.entidadTecnicaTotales = this.entidadTecnicaTotales.filter(item => item.fecha_de_facturacion === this.FechaDeFacturacionSeleccionada)
        }
        if (this.estadoDeNegociacionSeleccionado !== 'Todos') {
          this.entidadTecnicaTotales = this.entidadTecnicaTotales.filter(item => item.estado_de_negociacion === this.estadoDeNegociacionSeleccionado)
        }
        if (this.estadoEntidadTecnicaSeleccionado !== 'Todos') {
          this.entidadTecnicaTotales = this.entidadTecnicaTotales.filter(item => item.estado === this.estadoEntidadTecnicaSeleccionado)
        }
        if (this.asesorSeleccionado !== 'Todos') {
          this.entidadTecnicaTotales = this.entidadTecnicaTotales.filter(item => item.email_user === this.asesorSeleccionado)
        }
        this.isLoadingTable = false
      },
      async exportarExcel () {
        try {
          this.isLoadingDownload = true
        
          const data = [
            {
              sheet: 'E.T',
              columns: [
                { label: 'RUC', value: 'ruc' },
                { label: 'RAZON SOCIAL', value: 'razon_social' },
                { label: 'DIRECIÓN FISCAL', value: 'direccion_fiscal' },
                { label: 'DIRECIÓN REAL', value: 'direccion_real' },
                { label: 'ZONA', value: 'zona' },
                { label: 'ESTADO', value: 'estado' },
                { label: 'VIGENCIA', value: 'vigencia' },
                { label: 'EMAIL', value: 'email_user' },
                { label: 'MEDIO DE CONTACTO', value: 'medio_de_contacto' },
                { label: 'PROVEEDOR ACTUAL', value: 'proveedor_actual' },
                { label: 'DEPARTAMENTO FISCAL', value: 'departamento_fiscal' },
                { label: 'PROVINCIA FISCAL', value: 'provincia_fiscal' },
                { label: 'DEPARTAMENTO REAL', value: 'departamento_real' },
                { label: 'PROVINCIA REAL', value: 'provincia_real' },
                { label: 'REPRESENTANTE LEGAL', value: 'representante_legal' },
                { label: 'TIPO DE CLIENTE', value: 'tipo_de_cliente' },
                { label: 'TIPO DE CONSTRUCCION', value: 'tipo_de_construccion' },
                { label: 'FOTO DIRECCION FISCAL', value: 'foto_direccion_fiscal' },
                { label: 'FOTO DIRECCION REAL', value: 'foto_direccion_real' },
                { label: 'MEDIO DE CONTACTO', value: 'medio_de_contacto' },
                { label: 'VERIFICADO DIRECCION FISCAL', value: 'verificado_direccion_fiscal_gps' },
                { label: 'VERIFICADO DIRECCION REAL', value: 'verificado_direccion_real_gps' },
                { label: 'LATITUD FISCAL', value: 'latitud_fiscal_gps' },
                { label: 'LONGITUD FISCAL', value: 'longitud_fiscal_gps' },
                { label: 'LATITUD REAL', value: 'latitud_real_gps' },
                { label: 'LONGITUD REAL', value: 'longitud_real_gps' },
                { label: 'CONTACTOS', value: 'contactos' },
                { label: 'COMENTARIOS', value: 'comentarios' },
                //NEGOCIACION
                { label: 'CANTIDAD DE MODULOS', value: 'cantidad_de_modulos' },
                { label: 'CONVOCATORIA', value: 'convocatoria' },
                { label: 'DEPARTAMENTO DE DESPACHO', value: 'departamento_de_despacho' },
                { label: 'ESTADO DE NEGOCIACION', value: 'estado_de_negociacion' },
                { label: 'FECHA DE FACTURACION', value: 'fecha_de_facturacion' },
                { label: 'GANO ENTIDAD TECNICA', value: 'gano_entidad_tecnica' },
                { label: 'PERDIO ENTIDAD TECNICA', value: 'perdio_entidad_tecnica' },
                { label: 'INCLUYE PUERTA PRINCIPAL', value: 'incluye_puerta_principal' },
                { label: 'MONTO EN SOLES', value: 'monto_en_soles' },
                { label: 'PORCENTAJE DE CIERRE', value: 'porcentaje_de_cierre' },

              ],
    
              content: [
                ...this.entidadTecnicaTotales
              ]
            }]
  
          const settings = {
            sheetName: 'Data',
            fileName: 'Entidades Tecnicas'
          }
  
          await xlsx(data, settings)
          this.isLoadingDownload = false
        } catch (error) {
          this.isLoadingDownload = false
        }
      },
    },
  }
</script>
